import React from "react";
import { MapPin, Clock, Phone, ShieldCheck } from "lucide-react";

const STATS = [
  { value: "5.0", label: "Google Rating" },
  { value: "15+", label: "Happy Customers" },
  { value: "100%", label: "Satisfaction" },
  { value: "Local", label: "Sonoma Owned" },
];

export default function About() {
  return (
    <section id="about" className="relative py-20 md:py-32 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-3">
              Our story
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
              A young man who genuinely loves what he does.
            </h2>
            <div className="mt-6 space-y-4 text-zinc-400 text-base md:text-lg leading-relaxed">
              <p>
                B&amp;B Auto Detailing started right here in Sonoma County — built on long hours,
                attention to detail, and a simple belief: every car deserves to feel new again.
              </p>
              <p>
                B&amp;B Auto Detailing comes to you. We serve Santa Rosa &amp; surrounding areas
                within Sonoma County with our premium <span className="text-cyan-400 font-semibold">mobile detailing services</span>.
              </p>
              <p>
                We don't rush. We don't skip steps. From the wheel wells to the headliner,
                every surface gets the treatment it needs. That's why our reviews keep saying
                the same thing — <span className="text-cyan-400 font-semibold">amazing work,
                great communication, and results you can see.</span>
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-4 max-w-lg" data-testid="about-stats">
              {STATS.map((s) => (
                <div key={s.label} className="rounded-xl border border-zinc-800 bg-zinc-900/40 p-5">
                  <div className="text-3xl md:text-4xl font-black tracking-tighter text-cyan-400">
                    {s.value}
                  </div>
                  <div className="text-xs text-zinc-500 uppercase tracking-wider mt-1">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 space-y-4">
            <InfoCard
              icon={MapPin}
              title="Service Area"
              body="Santa Rosa, Sonoma County, and surrounding neighborhoods."
              testid="info-area"
            />
            <InfoCard
              icon={Clock}
              title="Hours"
              body="Open daily · Closes 8 PM. Same-day appointments often available."
              testid="info-hours"
            />
            <InfoCard
              icon={Phone}
              title="Call or Text"
              body={
                <a href="tel:+17079090231" className="hover:text-cyan-400 transition-colors">
                  (707) 909-0231
                </a>
              }
              testid="info-phone"
            />
            <InfoCard
              icon={ShieldCheck}
              title="Satisfaction Promise"
              body="If something isn't right, we'll make it right. No questions."
              testid="info-promise"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoCard({ icon: Icon, title, body, testid }) {
  return (
    <div
      className="rounded-2xl border border-zinc-800 bg-zinc-900/40 backdrop-blur-md p-6 flex items-start gap-4 hover:border-cyan-500/40 transition-all"
      data-testid={testid}
    >
      <div className="h-10 w-10 rounded-lg bg-cyan-400/10 border border-cyan-400/20 flex items-center justify-center shrink-0">
        <Icon className="h-5 w-5 text-cyan-400" />
      </div>
      <div>
        <div className="font-semibold text-zinc-100">{title}</div>
        <div className="text-sm text-zinc-400 mt-0.5">{body}</div>
      </div>
    </div>
  );
}
